import axios from "axios";
import env from "@/Environment";
import router from '@/router'
import store from '@/store'

let interval = 0

const api = axios.create({
    baseURL: env.apiBackendUrl
})

export const setToken = (token: string) => {
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    interval = window.setInterval(() => {
        const creation = localStorage.getItem('next-token-created_at')
        const diff = (new Date()).getTime() - parseInt(creation || '0')
        if(diff > 86400000) {
            clearInterval(interval)
            return store.dispatch('logout').then(_ => {
                return router.push({name: 'Login'})
            })
        }
    }, 1000)
}
export const removeToken = () => {
    delete api.defaults.headers.common['Authorization'];
}

api.defaults.withCredentials = true;
api.interceptors.response.use(response => response, error => {
        if (error.request.status == 401) {
            store.dispatch('logout').then(_=>router.push({name: 'Login'}))
        }
        return Promise.reject(error)
    }
);

export default api;
